import { useMemo, type ReactNode } from "react";
import { buildLookup, type ChangeSet } from "@archlang/engine";
import { DiffContext } from "./useDiffLookup.js";

export function DiffProvider({
  changeSet,
  children,
}: {
  changeSet: ChangeSet | null;
  children: ReactNode;
}) {
  const lookup = useMemo(() => (changeSet ? buildLookup(changeSet) : null), [changeSet]);
  return <DiffContext.Provider value={lookup}>{children}</DiffContext.Provider>;
}
